import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore, REDIRECT_URL_KEY } from '@vantage-web/core-data';

/**
 * Protects Subcontractor portal routes.
 * Admits a Sub-portal role **or** an OIP identity bearing the cross-portal Sub Proxy
 * grant (capability, not role-equality — ADR-015; the role/capability map of record is
 * `docs/rbac-matrix.md`).
 */
export const subPortalAuthGuard: CanActivateFn = (_route, state) => {
  const store = inject(AuthStore);
  const router = inject(Router);

  if (!store.isAuthenticated()) {
    if (state.url !== '/auth/login') {
      localStorage.setItem(REDIRECT_URL_KEY, state.url);
    }
    return router.parseUrl('/auth/login');
  }

  if (!store.isSubUser() && !store.hasSubProxyGrant()) {
    return router.parseUrl('/auth/login');
  }

  return true;
};

/**
 * Protects Client portal routes.
 * Requires authentication + the CLIENT role (custom:role = 'CLIENT').
 */
export const clientPortalAuthGuard: CanActivateFn = (_route, state) => {
  const store = inject(AuthStore);
  const router = inject(Router);

  if (!store.isAuthenticated()) {
    if (state.url !== '/auth/login') {
      localStorage.setItem(REDIRECT_URL_KEY, state.url);
    }
    return router.parseUrl('/auth/login');
  }

  if (!store.isClientUser()) {
    return router.parseUrl('/auth/login');
  }

  return true;
};
